import axios from 'axios';
import store from '../store';

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_ROOT,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

let token = '';

export default {
  getCurrent(lat: number, lon: number) {
    token = store.getters.token;
    return apiClient.get('/api/weather/current', {
      headers: { Authorization: `Bearer ${token}` },
      params: { lat, lon },
    });
  },

  getTileUrl(layer: string) {
    const baseUrl = (process.env.VUE_APP_API_ROOT || '').replace(/\/$/, '');
    return `${baseUrl}/api/weather/tile/${encodeURIComponent(
      layer
    )}/{z}/{x}/{y}.png`;
  },
};
